import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const CallbackPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, isChro, loading } = useAuth();

  useEffect(() => {
    // Wait for auth to complete, then redirect
    if (!loading) {
      if (isAuthenticated) {
        if (isAdmin) {
          navigate('/admin', { replace: true });
        } else if (isChro) {
          navigate('/signal-room', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } else {
        // Auth failed, redirect to login
        navigate('/login', { replace: true });
      }
    }
  }, [loading, isAuthenticated, isAdmin, isChro, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Completing authentication...</p>
    </div>
  );
};

export default CallbackPage;
